import UserControl from '@/core/components/UserControl/UserControl';

export default UserControl;
